import TinCan from "tincanjs";
import _ from "lodash";
import tree from "../../state";
import PlayerPaths from "../../constants/paths/playerPaths";
import TinCanConstants from "../../constants/tincan";
import { restoreStateForObject } from "../peristenceUtils";
import StatementGenerator from "./StatementGenerator";
import * as actions from "../../actions/actions";
import * as playerActions from "../../actions/playerActions";

export default class PersistenceManagerTinCan {

	constructor(config) {
		this.config = config;
		this.languageCode = "en-US"; //TODO: get from state tree
		this.activities = {};
		this.statements = [];

		let user = tree.get(["user"]);

		if (config.externalActivity) {
			this.agent = new TinCan.Agent({
				name: user.identityId,
				account: new TinCan.AgentAccount({
					homePage: config.account.homePage,
					name: user.identityId
				})
			});
		}

		//activity is outside LMS if externalActivity = true
		let tinCanConfig = {};

		if (!config.externalActivity) {
			tinCanConfig.url = window.location.href;
		}

		tinCanConfig.recordStores = config.recordStores;

		this.tinCan = new TinCan(tinCanConfig);

		this.statements = [];
	}

	//get all responses and set interaction count
	async init(params) {
		let activities = params.activities;
		tree.set(PlayerPaths.ROOT_ACTIVITY_ID, activities[0].id);

		let globalState = await this.getStateValue("globalState", this.getRootActivity(), this.agent);

		try {
			this.initialSuspendData = (globalState !== "") ? JSON.parse(globalState) : {};
		} catch (e) {
			console.error("Unable to get global state: " + e);
			this.initialSuspendData = {};
		}

		//console.log(JSON.stringify(this.initialResponses, null, 4));	
		actions.setActivities(tree, activities);
	}

	async save(params) {
		await this.saveState();
		await this.saveStatements();
	}

	async saveAndExit() {

		//TODO: Determine if everything is complete then use exitAll for nav request
		this.statements = this.statements.concat(StatementGenerator.generateExitStatements(this.rootActivity, this.agent));

		await this.save();

		if (this.config.closeWindowOnExit !== false) {
			window.close();
		} else {
			let activity = tree.get(PlayerPaths.ACTIVITY);
			return {
				activity
			}
		}
	}

	async saveResponse(item) {
		//no-op, save to state at end
	}

	async setCompletionState(completionState) {
		//no-op, really needs to live in delivery system
	}

	async trackHistory(historyItem, srcObj) {
		let currentActivity = tree.get(PlayerPaths.ACTIVITY);
		let currentTinCanActivity = this.activities[currentActivity.id];

		let statement = StatementGenerator.generateHistoryStatement(historyItem, srcObj, currentTinCanActivity, this.rootActivity, this.agent, this.languageCode);
		if (statement) {
			this.statements.push(statement);
		}
	}

	restoreActivityResponsesAndState(activity) {

		this.activities[activity.id] = {
			id: TinCanConstants.AMBIFI_BASE_URI + "/activities/" + activity.id,
			definition: new TinCan.ActivityDefinition({
				type: TinCanConstants.AMBIFI_ACTIVITY_TYPES.ACTIVITY,
				name: { [this.languageCode]: activity.name },
				description: { [this.languageCode]: activity.description }
			})
		}

		let rootActivityId = tree.get(PlayerPaths.ROOT_ACTIVITY_ID);
		if (activity.id === rootActivityId) {
			this.rootActivity = this.activities[rootActivityId];
			this.statements = this.statements.concat(StatementGenerator.generateInitializeStatement(this.rootActivity, this.agent));
		}

		//TODO: Handle activity array

		//console.log("RESTORING DATA FOR ACTIVITY " + activity.id);

		//using id for now since it stays consistent
		let suspendData = this.initialSuspendData[activity.id];

		//restore activity values from initial lms load
		if (activity.children && suspendData) {

			if (suspendData.hasOwnProperty("selected")) {
				activity.selected = suspendData.selected;
			}

			if (suspendData.hasOwnProperty("selectedListIndex")) {
				activity.selectedListIndex = suspendData.selectedListIndex;
			}

			if (suspendData.variables) {
				activity.variables = suspendData.variables;
			}

			for (let i = 0; i < activity.children.length; i++) {

				let list = activity.children[i];
				if (list.type === "list" && list.children) {

					let listState = suspendData.objects[list.guid];

					if (!_.isUndefined(listState)) {
						if (listState.hasOwnProperty("completionState")) {
							list.completionState = listState.completionState;
						}
					}

					for (let j = 0; j < list.children.length; j++) {

						let section = list.children[j];
						if (section.type === "section" && section.children) {

							let sectionState = suspendData.objects[section.guid];

							if (!_.isUndefined(sectionState)) {
								if (sectionState.hasOwnProperty("completionState")) {
									section.completionState = sectionState.completionState;
								}
							}

							for (let k = 0; k < section.children.length; k++) {
								let item = section.children[k];
								let itemState = suspendData.objects[item.guid];

								if (!_.isUndefined(itemState)) {
									restoreStateForObject(item, itemState, item);
								}
							}
						}
					}
				}
			}
		}

		return activity;
	}

	async saveState() {
		await this.setStateValue("globalState", JSON.stringify(this.buildSuspendData()), this.getRootActivity(), this.agent);
	}

	async saveStatements() {
		let self = this;
		return new Promise(function (resolve, reject) {
			if (self.statements.length > 0) {
				var statementsCallback = function (err, result) {
					if (err !== null && err[0].err === null) {
						self.statements = [];
						resolve('');
					} else {
						var error = new Error('An error occurred saving Tin Can statements, status code: ' + err[0].err);
						error.status = err[0].err;
						reject(error);
					}
				};
				self.tinCan.sendStatements(self.statements, statementsCallback);
			} else {
				resolve('');
			}
		});
	}

	setStateItemResponseFromItem(stateItem, item) {
		let type = item.type.toLowerCase();

		//TODO: need to determine what values to store as part of learner response
		switch (type) {
			case "item":
			case "itemtextinput":
			case "itemtextinputmultiline":
			case "itemtime":
			case "itemdate":
			case "itemdatetime":
			case "itempicker":
			case "itemyesno":
			case "itemchoicesingle":
			case "itemaddress": //object
			case "itemlocation": //object
			case "itemimagepicker": //value, valueUrls
			case "itemchoicemulti": //array
				if (item.value) stateItem.value = item.value;
				break;
			case "itembarcodescanner":
				if (!_.isUndefined(item, "barcode.data")) _.set(stateItem, "barcode.data", _.get(item, "barcode.data"));
				break;
			default:
				if (item.value) stateItem.value = item.value;
				break;
		}
	}

	unloadHandler() {
		this.saveAndExit();
	}

	buildSuspendData() {

		let suspendData = {};

		//need to loop over all activities		
		let activities = tree.get(PlayerPaths.ACTIVITIES);

		let currentActivity = tree.get(PlayerPaths.ACTIVITY);

		suspendData[currentActivity.id] = this.buildSuspendDataForActivity(currentActivity);

		_.each(activities, (activity) => {
			if (activity.id !== currentActivity.id) {
				suspendData[activity.id] = this.buildSuspendDataForActivity(activity);
			}
		});

		return suspendData;
	}

	buildSuspendDataForActivity(activity) {

		let self = this;

		let activitySuspendData = {
			objects: {},
			selected: activity.selected,
			selectedListIndex: activity.selectedListIndex,
			variables: activity.variables
		}

		if (activity.children) {
			for (let i = 0; i < activity.children.length; i++) {

				let list = activity.children[i];
				if (list.type === "list" && list.children) {

					activitySuspendData.objects[list.guid] = {
						type: "list",
						completionState: list.completionState
					}

					for (let j = 0; j < list.children.length; j++) {

						let section = list.children[j];
						if (section.type === "section" && section.children) {

							activitySuspendData.objects[section.guid] = {
								type: "section",
								completionState: section.completionState
							}

							for (let k = 0; k < section.children.length; k++) {
								let item = section.children[k];

								let stateItem = {
									type: "item",
									completionState: item.completionState,
									checked: item.checked,
									enabled: item.enabled,
									notes: item.notes
								}

								self.setStateItemResponseFromItem(stateItem, item);
								activitySuspendData.objects[item.guid] = stateItem;
							}
						}
					}
				}
			}
		}

		return activitySuspendData;
	}

	getStateValue(stateId, activity, agent) {
		let self = this;
		return new Promise(function (resolve, reject) {
			var callback = function (err, result) {
				if (err === null) {
					if (result !== null && result.contents !== null) {
						resolve(result.contents);
					} else {
						resolve('');
					}
				} else {
					var error = new Error('An error occurred getting Tin Can state, stateId: ' + stateId + ', activityId: ' + activity.id + ', status code: ' + err);
					error.status = err;
					reject(error);
				}
			};

			self.tinCan.getState(
				stateId,
				{
					agent: agent,
					activity: activity,
					callback: callback
				}
			);
		});
	}

	setStateValue(stateId, value, activity, agent, contentType) {
		let self = this;
		return new Promise(function (resolve, reject) {
			var callback = function (err, result) {
				if (err === null) {
					resolve(value);
				} else {
					var error = new Error('An error occurred saving Tin Can state, stateId: ' + stateId + ', activityId: ' + activity.id + ', status code: ' + err);
					error.status = err;
					reject(error);
				}
			};

			self.tinCan.setState(
				stateId,
				value,
				{
					agent: agent,
					activity: activity,
					callback: callback,
					contentType: contentType
				}
			);
		});
	}

	getRootActivity() {
		let rootActivityId = tree.get(PlayerPaths.ROOT_ACTIVITY_ID);
		let rootActivity;
		if (_.isUndefined(this.rootActivity)) {
			rootActivity = {
				id: TinCanConstants.AMBIFI_BASE_URI + "/activities/" + rootActivityId,
				definition: new TinCan.ActivityDefinition({
					name: { [this.languageCode]: "Temp root activity" },
					description: { [this.languageCode]: "Temp root activity" }
				})
			};
		} else {
			rootActivity = this.rootActivity;
		}
		return rootActivity;
	}

	async loadActivity(activityId, initialItemId) {
		return playerActions.loadPublishedActivity(activityId, initialItemId);
	}

	async uploadMediaFile(fileData, fileName, targetType, identityId) {
		return Promise.resolve({ url: "" });
	}
}
